module.exports = __webpack_public_path__ + "img/login.d1d70ff1.svg";